import api from '@admin/api/service';

const BASE_PATH = '/singgahsini/api/owner-program';

const MULTIPART_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'multipart/form-data',
};

export default {
  getOwnerPrograms(params) {
    return api.get(BASE_PATH, { params });
  },

  getOwnerProgram(id) {
    return api.get(`${BASE_PATH}/${id}`);
  },

  getOwnerProgramResultSummary(id) {
    return api.get(`${BASE_PATH}/${id}/result/summary`);
  },

  getOwnerProgramResult(id, params) {
    return api.get(`${BASE_PATH}/${id}/result`, { params });
  },

  uploadBanner(payload) {
    return api.post(`${BASE_PATH}/banner`, payload, {
      headers: MULTIPART_HEADERS,
    });
  },

  createOwnerProgram(payload) {
    return api.post(BASE_PATH, payload, { headers: MULTIPART_HEADERS });
  },

  updateOwnerProgram(id, payload) {
    payload.append('_method', 'PATCH');

    return api.post(`${BASE_PATH}/${id}`, payload, {
      headers: MULTIPART_HEADERS,
    });
  },

  stopOwnerProgram(id) {
    return api.patch(`${BASE_PATH}/${id}/stop`);
  },

  deleteOwnerProgram(id) {
    return api.delete(`${BASE_PATH}/${id}/destroy`);
  },
};
